import format from 'date-fns/format'

// @TODO use instead https://github.com/axios/axios/issues/1548
// eslint-disable-next-line
Date.prototype.toJSON = function() {
  return format(this, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
}
